import React, { Component } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';

import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';

import { getApi } from '../App';

export class AddGastosModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tipoGastos: [],
      tipoGasto: 0,
      fechaGasto: '', // guardamos YYYY-MM-DD aquí
      snackbarOpen: false,
      snackbarmsg: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTipoChange = this.handleTipoChange.bind(this);
    this.handleFechaChange = this.handleFechaChange.bind(this);
  }

  // Convierte 'YYYY-MM-DD' -> 'YYYY-MM-DDT00:00:00.000-03:00' según zona local
  toLocalOffsetISO(dateStr) {
    if (!dateStr) return undefined;
    const offsetMin = -new Date().getTimezoneOffset(); // invierte el signo para construir ±HH:mm
    const sign = offsetMin >= 0 ? '+' : '-';
    const abs = Math.abs(offsetMin);
    const hh = String(Math.floor(abs / 60)).padStart(2, '0');
    const mm = String(abs % 60).padStart(2, '0');
    return `${dateStr}T00:00:00.000${sign}${hh}:${mm}`;
  }

  componentDidMount() {
    getApi()
      .getTipoGastos()
      .then((data) => {
        this.setState({ tipoGastos: data || [] });
      });

    // Inicializa fecha por defecto a HOY (YYYY-MM-DD) sin cambiar de día por la zona
    const hoy = new Date();
    hoy.setMinutes(hoy.getMinutes() - hoy.getTimezoneOffset());
    const min_date = hoy.toISOString().slice(0, 10);
    this.setState({ fechaGasto: min_date });
  }

  snackbarClose = () => {
    this.setState({ snackbarOpen: false });
  };

  handleTipoChange(event) {
    const valor = event.target.value.toString().trim();
    this.setState({ tipoGasto: event.target.value });
    console.log('Tipo Gasto Valor', valor);
  }

  handleFechaChange(event) {
    this.setState({ fechaGasto: event.target.value }); // 'YYYY-MM-DD'
    console.log('Fecha Gasto', event.target.value);
  }

  handleSubmit(event) {
    event.preventDefault();

    const fechaISOConOffset = this.toLocalOffsetISO(this.state.fechaGasto);

    const data = {
      id: null,
      idExpediente: this.props.idExpediente,
      tipoGasto: this.state.tipoGasto,
      // Opción recomendada: enviar fecha con offset local explícito
      fecha: fechaISOConOffset,
      // Si tu backend acepta solo fecha (LocalDate), usa en su lugar:
      // fecha: this.state.fechaGasto,

      monto: event.target.monto.value,
      // El name del input es "nrofactura" (en minúsculas)
      facturaNroStr: event.target.nrofactura.value,
      proveedor: event.target.proveedor.value,
      // Mantengo 'resposable' como lo tenías, por si el backend espera esa clave tal cual
      resposable: event.target.proveedor.value
    };

    console.log('Payload a guardar:', data);

    getApi()
      .saveGastos(data)
      .then((res) => res.json())
      .catch((error) => {
        console.error('Error:', error);
      })
      .then((response) => {
        console.log('Success:', response);
        this.setState({
          snackbarOpen: true,
          snackbarmsg: 'El registro se guardó correctamente'
        });
        this.props.onClose();
      });
  }

  render() {
    const { fechaGasto, tipoGasto, tipoGastos } = this.state;

    return (
      <div className="container">
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.snackbarOpen}
          autoHideDuration={3000}
          onClose={this.snackbarClose}
          message={<span id="message-id">{this.state.snackbarmsg}</span>}
          action={[
            <IconButton
              key="close"
              arial-label="Cerrar"
              color="inherit"
              onClick={this.snackbarClose}
            >
              x
            </IconButton>
          ]}
        />
        <Modal {...this.props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained_modal_title_vcenter">
              Agregar gastos al expediente {this.props.idExpediente}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6}>
                <Form onSubmit={this.handleSubmit}>
                  <Form.Group controlId="fechaGasto">
                    <Form.Label>Fecha:</Form.Label>
                    <Form.Control
                      onChange={this.handleFechaChange}
                      type="date"
                      name="fecha"
                      value={fechaGasto || ''}
                      required
                      placeholder="Fecha del gasto"
                    />
                  </Form.Group>

                  <Form.Group controlId="monto">
                    <Form.Label>Monto:</Form.Label>
                    <Form.Control type="number" name="monto" required placeholder="Monto del gasto" />
                  </Form.Group>

                  <Form.Group controlId="tipoGasto">
                    <Form.Label>Concepto:</Form.Label>
                    <Form.Control as="select" value={tipoGasto} onChange={this.handleTipoChange}>
                      {tipoGastos.map((tp) => (
                        <option key={tp.identificador} value={tp.identificador}>
                          {tp.Descrip}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>

                  <Form.Group controlId="nroFactura">
                    <Form.Label>Nro. de Factura:</Form.Label>
                    <Form.Control
                      type="text"
                      name="nrofactura"
                      maxLength="15"
                      required
                      placeholder="Nro. de la Factura"
                    />
                  </Form.Group>

                  <Form.Group controlId="proveedor">
                    <Form.Label>Proveedor:</Form.Label>
                    <Form.Control
                      type="text"
                      name="proveedor"
                      maxLength="30"
                      required
                      placeholder="Proveedor del gasto"
                    />
                  </Form.Group>

                  <Form.Group>
                    <Button variant="primary" type="submit">
                      Grabar
                    </Button>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={this.props.onHide}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddGastosModal;
